import { formatNumber } from "src/v2/utils/formatter/format-number"
import { formatDateString } from "src/utils/format-date"

const formatDate = (date) => {
    if (!date) return "-"
    return formatDateString(date, "-")
}

const hasValue = (value) => {
    return value !== null && value !== undefined && value !== ""
}

const hasAnyValue = (values) => {
    return values.some(hasValue)
}

const getValue = (value) => {
    return hasValue(value) ? value : "Não"
}

export const getSummarySections = ({
    garantiasData,
    offerData,
    fatosRelevantesData,
    handleClickEmission,
    stateRating,
    stateDebtorEmission,
    statePriceProcess,
    lastBusinessState,
    stateIndexLiquidity,
    lastEventCreditEmissionState,
    lastEventCreditDebtorState,
}) => {
    const ultimoFatoRelevante = fatosRelevantesData?.[0]
    const lastRating = stateRating?.rows?.[0] || {}
    const lastDebtor = stateDebtorEmission?.rows?.[0] || {}
    const lastPrice = statePriceProcess?.rows?.[0] || {}
    const lastBusiness = lastBusinessState?.rows?.[0] || {}
    const lastIndex = stateIndexLiquidity?.rows?.[0] || {}
    const lastEventEmission = lastEventCreditEmissionState?.rows?.[0] || {}
    const lastEventDebtor = lastEventCreditDebtorState?.rows?.[0] || {}

    return [
        {
            title: "Último Rating Emissão",
            gridProps: { xxxs: 4, sm: 6, lg: 4 },
            empty: !stateRating?.rows?.length,
            emptyText: "Não há rating de emissão para o CETIP consultado",
            onClick: () => handleClickEmission("last_emission"),
            fields: [
                {
                    label: "DATA VALIDADE",
                    value: formatDate(lastRating?.DataValidade),
                },
                {
                    label: "FONTE",
                    value: lastRating?.Fonte,
                },
                {
                    label: "RATING",
                    value: lastRating?.Rating,
                },
            ],
        },
        {
            title: "Último Rating Devedor",
            gridProps: { xxxs: 4, sm: 6, lg: 4 },
            empty: !stateDebtorEmission?.rows?.length,
            emptyText: "Não há rating devedor para o CETIP consultado",
            onClick: () => handleClickEmission("last_debtor"),
            fields: [
                {
                    label: "DATA VALIDADE",
                    value: formatDate(lastDebtor?.DataValidade),
                },
                {
                    label: "FONTE",
                    value: lastDebtor?.Fonte,
                },
                {
                    label: "RATING",
                    value: lastDebtor?.Rating,
                },
            ],
        },
        {
            title: "Garantias",
            gridProps: { xxxs: 4, sm: 6, lg: 4 },
            empty:
                !garantiasData ||
                (garantiasData?.garantias_reais?.garantias_reais !== "1" &&
                    garantiasData?.garantias_fidejussorias?.garantias_fidejussorias !== "1" &&
                    garantiasData?.mitigadores?.mitigador_risco_credito !== "1"),
            emptyText: "Não há garantias para o CETIP consultado",
            onClick: () => handleClickEmission("guarantees"),
            fields: [
                {
                    label: "REAIS",
                    value:
                        garantiasData?.garantias_reais?.garantias_reais === "1"
                            ? "Sim"
                            : "Não",
                },
                {
                    label: "FIDEJUSSORIAS",
                    value:
                        garantiasData?.garantias_fidejussorias?.garantias_fidejussorias === "1"
                            ? "Sim"
                            : "Não",
                },
                {
                    label: "MITIGADORES RISCO CREDITO",
                    value:
                        garantiasData?.mitigadores?.mitigador_risco_credito === "1"
                            ? "Sim"
                            : "Não",
                },
            ],
        },
        {
            title: "Última Taxa Indicativa",
            gridProps: { xxxs: 4, sm: 6, lg: 4 },
            empty: !statePriceProcess?.rows?.length,
            emptyText: "Não há taxa indicativa para o CETIP consultado",
            onClick: () => handleClickEmission("tax_indicative"),
            fields: [
                {
                    label: "DATA REFERENCIA",
                    value: formatDate(lastPrice?.DataReferencia),
                },
                {
                    label: "SPREAD CRÉDITO",
                    value: formatNumber(lastPrice?.SpreadCredito, 4),
                },
                {
                    label: "% PUPAR",
                    value: formatNumber(lastPrice?.PercentualPUPAR, 4),
                },
            ],
        },
        {
            title: "Últimos Negócios",
            gridProps: { xxxs: 4, sm: 6, lg: 4 },
            empty: !lastBusinessState?.rows?.length,
            emptyText: "Não há negócios para o CETIP consultado",
            onClick: () => handleClickEmission("history_last_negocitacions"),
            fields: [
                {
                    label: "DATA REFERENCIA",
                    value: formatDate(lastBusiness?.DataReferencia),
                },
                {
                    label: "% PUPAR",
                    value: formatNumber(lastBusiness?.PercentualPUPAR, 4),
                },
                {
                    label: "SPREAD CRÉDITO",
                    value: formatNumber(lastBusiness?.SpreadCreditoFinal, 4),
                },
            ],
        },
        {
            title: "Último Índice de Liquidez",
            gridProps: { xxxs: 4, sm: 6, lg: 4 },
            empty: !stateIndexLiquidity?.rows?.length,
            emptyText: "Não há índice de liquidez para o CETIP consultado",
            onClick: () => handleClickEmission("index_liquidity"),
            fields: [
                {
                    label: "DATA REFERENCIA",
                    value: formatDate(lastIndex?.DataReferencia),
                },
                {
                    label: "INDICE LIQUIDEZ",
                    value: formatNumber(lastIndex?.IndiceLiquidez, 4),
                },
            ],
        },
        {
            title: "Último Evento de Crédito Emissão",
            gridProps: { xxxs: 4, sm: 6, lg: 4 },
            empty: !lastEventCreditEmissionState?.rows?.length,
            emptyText: "Não há evento de crédito de emissão para o CETIP consultado",
            onClick: () => handleClickEmission("history_event_credit_emission"),
            fields: [
                {
                    label: "DATA REFERENCIA",
                    value: formatDate(lastEventEmission?.DataReferencia),
                },
                {
                    label: "SCORE EVENTO",
                    value: formatNumber(lastEventEmission?.ScoreEvento, 4),
                },
                {
                    label: "EVENTO CRÉDITO",
                    value: lastEventEmission?.EventoCreditoEmissao,
                    gridProps: { xxxs: 4, md: 8, lg: 8 },
                },
            ],
        },
        {
            title: "Último Evento de Crédito Devedor",
            gridProps: { xxxs: 4, sm: 6, lg: 4 },
            empty: !lastEventCreditDebtorState?.rows?.length,
            emptyText: "Não há evento de crédito devedor para o CETIP consultado",
            onClick: () => handleClickEmission("history_event_credit_debtor"),
            fields: [
                {
                    label: "DATA REFERENCIA",
                    value: formatDate(lastEventDebtor?.DataReferencia),
                },
                {
                    label: "SCORE EVENTO",
                    value: formatNumber(lastEventDebtor?.ScoreEvento, 4),
                },
                {
                    label: "EVENTO CREDITO",
                    value: lastEventDebtor?.EventoCreditoDevedor,
                    gridProps: { xxxs: 4, md: 8, lg: 8 },
                },
            ],
        },
        {
            title: "Tipo de Oferta",
            gridProps: { xxxs: 4, sm: 6, lg: 4 },
            empty: !hasAnyValue([offerData?.TipoOferta]),
            emptyText: "Não há dados de oferta para o CETIP consultado",
            onClick: () => handleClickEmission("offer_type"),
            fields: [
                {
                    label: "TIPO",
                    value: `Oferta ${getValue(offerData?.TipoOferta)}`,
                },
            ],
        },
        {
            title: "Último Fato Relevante",
            gridProps: { xxxs: 4, sm: 12, lg: 12 },
            empty: !hasAnyValue([
                ultimoFatoRelevante?.DataReferencia,
                ultimoFatoRelevante?.Fato,
            ]),
            emptyText: "Não há fato relevante para o CETIP consultado",
            onClick: () => handleClickEmission("relevant_facts_history"),
            fields: [
                {
                    label: "DATA REFERÊNCIA",
                    value: formatDate(getValue(ultimoFatoRelevante?.DataReferencia)),
                    gridProps: { xxxs: 4, sm: 3, lg: 2 },
                },
                {
                    label: "FATO",
                    value: getValue(ultimoFatoRelevante?.Fato),
                    gridProps: { xxxs: 4, sm: 9, lg: 10 },
                    valueSx: {
                        whiteSpace: "normal",
                        overflowWrap: "anywhere",
                        wordBreak: "break-word",
                        lineHeight: 1.35,
                    },
                },
            ],
        },
    ]
}